import { render, staticRenderFns } from "./AddAssignmentDetail.vue?vue&type=template&id=2214826b&scoped=true&"
import script from "./AddAssignmentDetail.vue?vue&type=script&lang=js&"
export * from "./AddAssignmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./AddAssignmentDetail.vue?vue&type=style&index=0&id=2214826b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2214826b",
  null
  
)

export default component.exports